<script lang="ts">

    export let number: number | string;
    export let featured: boolean;

    let width: number = 100;

</script>

<div class="number" bind:clientWidth={width}>
    <div class="circle" class:featured style="font-size: {width * 0.6}px; border-width: {width * 0.04}px">
        {number}
    </div>
</div>

<style lang="scss">

    .number {
        width: 100%;
        position: relative;

        &::before {
            content: '';
            display: block;
            padding-top: 100%;
        }
    }

    .circle {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: #222;
        border: 5px solid #fff;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        font-family: BingoNumber;

        &.featured {
            border: none;
            background-color: var(--color-secondary);
            color: #000;
        }
    }

</style>
